import { decodeHTML } from './supapress-v3-utilities'
import { formatCurrency } from '../utils/get-price'
import { getItemPosition } from './supapress-v3-insights'
/**
 * SupapressV3Book
 *
 */
class SupapressV3Book {
  constructor (supapressV3, item) {
    this.supapressV3 = supapressV3
    this.item = item
  }

  getIsbn13 () {
    if (typeof this.item.isbn13 === 'undefined') {
      return null
    }

    return this.item.isbn13
  }

  getSlug (handleText = null) {
    if (handleText === null) {
      return null
    }

    // TODO make this dynamic if this ever needs to be res-used

    return `/products/${handleText}/`
  }

  getSummary () {
    if (!this.item.description || window.theme.settings.showSummaryOnHover === 'false') {
      return null
    }

    return decodeHTML(this.item.description.replace(/<(?:.|\n)*?>/gm, '').substring(0, 100) + '...')
  }

  setupContributorLinks () {
    if (!this.item.contributors || this.item.contributors.length === 0) {
      return null
    }

    return this.item.contributors.map(contributor => {
      if (!contributor.name) {
        return ''
      }
      return contributor.name
    }).join(', ')
  }

  setupReadMoreBtn () {
    if (window.theme.settings.showReadMoreBtn === 'false' || this.getSlug(this.item.catalogAttributes.handle) === null) {
      return null
    }
    return `<a href="${this.getSlug(this.item.catalogAttributes.handle)}" class="grid-product__readmore btn btn--small" title="Go to ${this.item.title} book page">Read More</a>`
  }

  setupSalePrice () {
    if (
      !this.item.catalogAttributes ||
      !this.item.catalogAttributes.saleprice ||
      !this.item.catalogAttributes.saleprice.length
    ) return null
    return formatCurrency(this.item.catalogAttributes.saleprice[0])
  }

  setupPrice () {
    if (!this.item.prices || !Object.keys(this.item.prices).length) return null
    const storeCurrency = window.theme.settings.supaduCurrency.currency_iso || 'USD'
    const localePrice = this.item.prices[storeCurrency]
    if (!localePrice) return null
    const toFixedPrice = localePrice.toFixed(2)
    return formatCurrency(toFixedPrice.toString().replace('.', ''))
  }

  getBook () {
    if (
      !this.item ||
      !this.item.title ||
      !this.item.catalogAttributes ||
      !this.item.catalogAttributes.handle
    ) return null
    this.item.templateVars = {}
    this.item.templateVars.seoTitle = this.supapressV3.client.helpers.seoURL(this.item.title)
    this.item.templateVars.slug = this.getSlug(this.item.catalogAttributes.handle)
    this.item.templateVars.contributorString = this.setupContributorLinks()
    this.item.templateVars.price = this.setupPrice()
    this.item.templateVars.salePrice = this.setupSalePrice()
    this.item.templateVars.previewDesc = this.getSummary()
    this.item.templateVars.readMoreBtn = this.setupReadMoreBtn()
    this.item.image = this.supapressV3.client.helpers.resizeImage(this.item.image, 298)
    if (window.theme.settings.enableAlgoliaInsights === 'true') {
      this.item.queryID = this.supapressV3.bookSearch.helper.lastResults.queryID
      this.item.position = getItemPosition(this.item, this.supapressV3.bookSearch.helper.lastResults)
    }
    return this.item
  }
}

export default SupapressV3Book
